export const lensAddresses = {
  accountLens: "0x08bb803D19e5E2F006C87FEe77c232Dc481cB735",
  eulerEarnVaultLens: "0xeF3dcFeCB05C17188db3D21869A4586Af5D3B054",
  irmLens: "0x8D990f217879E3C49894024f5D72431DA3Ef656C",
  oracleLens: "0xC5FFCe5f0e6646D93F7E79bD71d268dFC1B7EfD7",
  utilsLens: "0x4117A65ef95d9e1f26394f7b6AD40CA49998AA70",
  vaultLens: "0xcC5F7593a4D5974F84A30B28Bd3fdb374319a254",
} as const
